$mol_icon_pause $mol_icon path \M14,19H18V5H14M6,19H10V5H6V19Z
